<template>
    <form class="">
        <!-- Basic Information -->
        <templates v-model="model.title"></templates>

        <!--<fieldset>
            <div class="form-body">
                <div class="form-group">
                    <txt label="title" v-model="model.title"></txt>
                </div>
            </div>&lt;!&ndash; .form-body &ndash;&gt;
        </fieldset>-->
        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store" :disabled="saving">
                <span v-if="!saving"><i class="icon icon-save"></i> Save</span>
                <span v-if="saving"><i class="icon icon-spinner fa-spin"></i> Saving</span>
            </button>
        </div>
    </form>
</template>

<script>
    import Templates from "./templates";
    export default {
        components: {Templates},
        props: {
            data: { default: '' },
            name: { default: '' },
        },
        data() {
            return {
                saving: false,
                model: {
                    clone_public_id: 0,
                    title: '',
                    type: 'htmlBlock',
                    content: '',
                },
            }
        },
        created() {
            this.$eventHub.$on('block-template', this.updateTemplate);
            this.$eventHub.$on('saving' + this.name, this.updateSaving);
        },
        methods: {
            updateTemplate(item) {
                this.model.clone_public_id = item.public_id;
                this.model.title = item.title;
            },
            updateSaving(value) {
                this.saving = value;
            },
            store() {
                let before = this.model;
                this.model = Object.assign({invoice_id: this.data.invoice_id}, this.model);
                this.$store('/api/proposal/post', this);
                this.model = before;
            },
            callback(data) {
                console.log('callback');
                location.reload();
            }
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('saving' + this.name, this.updateSaving);
        },
    }

</script>
